t = require('views/internal/teacup-with-helpers')('ent_org_prefs_nonorg_invites')

module.exports = t.renderable (enterprise) ->
  t.div ->
    t.p ->
      t.text ''
    t.p ->
      t.format 'who-can-be-added-to-boards-within-enterprise-teams'
    t.ul '.pop-over-list.normal-weight', ->
      t.li { class: t.classify('active': !enterprise.organizationPrefs.externalMembersDisabled) }, ->
        t.a { href: '#', 'data-restriction': 'undefined' }, ->
          t.strong ->
            t.format 'let-team-admins-decide'
          if enterprise.organizationPrefs.externalMembersDisabled is undefined
            t.icon 'check'
          t.span { class: 'sub-name' }, ->
            t.format 'team-admins-can-change'
      t.li { class: t.classify('active': enterprise.organizationPrefs.externalMembersDisabled) }, ->
        t.a { href: '#', 'data-restriction': 'true' }, ->
          t.strong ->
            t.format 'only-team-members'
          if enterprise.organizationPrefs.externalMembersDisabled == true
            t.icon 'check'
          t.span '.sub-name', ->
            t.format 'only-members-of-boards-teams-can-be-added'



// WEBPACK FOOTER //
// ./app/scripts/views/templates/ent_org_prefs_nonorg_invites.coffee